export enum PrintingOnType {
    EMPTY = 'Empty sheet',
    CONTAINING = 'Sheet containing some barcodes'
}
